import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 25,
    justifyContent: "space-between",
  },

  modal: {
    margin: 0,
    alignItems: "center",
    justifyContent: "center",
  },
  modalContainer: {
    flex: 1,
    padding: 16,
    alignItems: "center",
    justifyContent: "center",
  },
  modalClose: {
    position: "absolute",
    top: 16,
    left: 16,
  },
  modalSuccess: {
    width: 80,
    height: 80,
    marginBottom: 32,
  },
  modalText: {
    textAlign: "center",
    marginBottom: 16,
  },
  modalImage: {
    position: "absolute",
    width: 120,
    height: 120,
    right: 0,
    top: "80%",
  },
  textBold: {
    fontWeight: "bold",
  },
  copyText: {
    fontWeight: "bold",
    color: "green",
  },
});
